import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AddressService, IPartialAddress } from '../../services/address.service';
import { LoaderService } from '../../services/loader.service';
import { finalize } from 'rxjs/operators';
import { AlertController } from '@ionic/angular';
import { StoreService } from 'src/app/store/services/store.service';
//import { removeSummaryDuplicates } from '@angular/compiler';
import { AlertService } from '../../services/alert.service';
import { IStore } from 'src/app/store/services/store.service';
import { SettingService } from '../../services/setting.service';
import { ValidatorsService } from '../../services/validators.service';
import { TranslationService } from '../../services/translation.service';
@Component({
    selector: 'shared-postal-code-form',
    templateUrl: './postal-code-form.component.html',
    styleUrls: ['./postal-code-form.component.scss'],
    standalone: false
})
export class PostalCodeFormComponent implements OnInit {
  form: FormGroup;
  formErrors: Map<string, string> = new Map<string, string>();
  allowOtherProvince: boolean;
  @Input() skipProvinceValidation: boolean=false;
  @Input() isReservation:boolean;
  @Input() postalCode;
  dontTakeOrders: boolean=false;
  @Output()
  onPostalCodeValidated: EventEmitter<IPartialAddress[]> = new EventEmitter<IPartialAddress[]>();

  patternReference: any = {};

  private _label:string;
  store:IStore;
  @Input() set label(value: string) {
    this._label = value;
  }

  get label(): string {
    return this._label;
  }

  constructor(
    //private translateService: TranslateService,
    public settingService: SettingService,
    private storeService: StoreService,
    private alertCtrl: AlertController,
    private fb: FormBuilder, 
    private addressService: AddressService,
    private loaderService: LoaderService,
    private alertService: AlertService,
    public validators: ValidatorsService,
    private translationService: TranslationService) { }

  ngOnInit() {
    /*
    this.form = this.fb.group({
      'postalCode': ['', this.validators.formBuilderValidationInitializer(true, null, null)]
    });
    */
    this.form = this.fb.group({
      postalCode: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true, null, null),
        updateOn: 'change'
      })
    });

    /*
    this.form["patternReference"] = {
      postalCode: null
    };
    */
   this.patternReference = {
      postalCode: null
    };

    this.validators.trackInputChange(this.form, this.patternReference);


    if(this.isReservation){
      this.storeService.getStore(localStorage.getItem('ReservationStoreId')).subscribe(store=>{
        this.store = store;
      });
    } else {
      this.storeService.getStore(localStorage.getItem('StoreId')).subscribe(store=>{
        this.store = store;
        if(this.postalCode != null){
          this.form.get('postalCode').setValue(this.postalCode);
          this.submit();
        }
      });
    }
  }

alertNoDelivery()
{
  this.alertCtrl.create({
    header:  this.translationService.translate('Checkout.WrongPostalCodeHeading'),
    message: this.translationService.translate('Checkout.WrongPostalCode'),
    buttons: [
      {
        text: 'Okay',
        role: 'cancel',
        cssClass: 'secondary',
        handler: () => {
          
        }
      }
    ]
  }).then(al=>{
    al.present();
  });
  this.form.get('postalCode').setValue('');
}

  async submit() {

    //sanitizing
    this.form.setValue(this.validators.multiSanitizerInput(this.form.value));

    //Just to clear the form when changed the postalcode when a previous search has been done
    this.onPostalCodeValidated.emit([]);

    if (!this.form.valid)
      return;

    let postalCode = this.form.get('postalCode').value;

    const loader = await this.loaderService.create();
    this.addressService
      .findByPostalCode(postalCode)
      .pipe(finalize(async () => {
        await loader.dismiss();
      }))
      .subscribe((result: IPartialAddress[]) => {
        result.map((value) => {
          value.postalCode = postalCode;
        })
        let addressValid=1;

        if (result.length == 0) {
          this.alertService.showTranslate('Address.InvalidPostalCode');
          return;
        }
        if(!this.skipProvinceValidation)
        {
          if(this.store.address.province!=result[0].provinceCode)
          { 
            
            //Store level logic
      
            if(this.store.allowedProvince !=null )
            {
         
              if(!this.store.allowedProvince.allowOtherProvince)
              {
                  this.alertNoDelivery();
                  return;
              }
              else 
              {
               addressValid=this.store.allowedProvince.allowedProvinces.findIndex(province=>province==result[0].provinceCode);
                 if(addressValid<0)
                 { 
                   this.alertNoDelivery();
                   return;
                 }
              }
            }
          //Merchant logic
            else 
            { 
                if(this.settingService.configuration.allowedProvince!=null)
                {
                  if(!this.settingService.configuration.allowedProvince.allowOtherProvince)
                  {
                      this.alertNoDelivery();
                      return;
                  }
                  else
                  {
                    addressValid=this.settingService.configuration.allowedProvince.allowedProvinces.findIndex(province=>province==result[0].provinceCode);
                    if(addressValid<0)
                    { 
                      this.alertNoDelivery();
                      return;
                    }
                  }
              }
          }
        }
      }
     
      this.onPostalCodeValidated.emit(result);
      });
          this.formErrors.clear();
  }

  validate() {
     //Postal code custom validation
     //Might consider changing it to mask later
     let postalLength: number = this.form.get('postalCode').value;
     //Must be in UpperCase to match the SeeMyStore postal code validation
     this.form.get('postalCode').setValue(postalLength.toString().toUpperCase());
    
     if (postalLength.toString().length > 7) {
       this.form.get('postalCode').setValue(postalLength.toString().substring(0, 7));
     }
  }
}
